// extracted by mini-css-extract-plugin
export default {"space":"ModifyInfo_space__euzuK","row":"ModifyInfo_row__QdrgW","placeHolderShimmer":"ModifyInfo_placeHolderShimmer__zEb2g"};